/**
 * Remove email fields from website template payloads before rendering.
 * This keeps public contact sections phone-only across templates.
 */
export const stripEmailFromTemplateData = (value) => {
  if (typeof value === 'string') {
    if (/@/.test(value)) return '';
    if (/\bemail\b/i.test(value)) return '';
    return value;
  }

  if (Array.isArray(value)) {
    return value.map((item) => stripEmailFromTemplateData(item));
  }

  if (!value || typeof value !== 'object') {
    return value;
  }

  const sanitized = {};
  Object.entries(value).forEach(([key, child]) => {
    if (String(key).toLowerCase().includes('email')) return;
    sanitized[key] = stripEmailFromTemplateData(child);
  });

  return sanitized;
};
